<template>
  <div class="item"
    :style="itemStyle.listTypeItem"
    @click="setDetail(item)">
    <div v-if="itemStyle.img" class="img" :style="itemStyle.img">
      <img :src="getItemThumb(item)" alt="">
      <button v-if="isCollectableUser && collectionIcon"
        type="button"
        class="btnCollection"
        @click.stop="toggleCollection(item)">
        <img :src="isMyCollection ? collectionIcon.active : collectionIcon.default" alt="" :style="{width: collectionIcon.size}">
      </button>
    </div>
    <div class="text">
      <div class="left">
        <div class="name" v-if="itemStyle.name" :style="itemStyle.name">
          <pre>{{ item.collectionItemName[lang] }}</pre>
        </div>
        <div class="descTop" v-if="itemStyle.descTop" :style="itemStyle.descTop">
          <pre>{{ item.attribute.descTop[lang] }}</pre>
        </div>
      </div>
      <div class="right">
        <div class="descBottom" v-if="itemStyle.descBottom" :style="itemStyle.descBottom">
          <pre>{{ item.attribute.descBottom[lang] }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollectionItem',
  props: [
    'locale',
    'lang',
    'categoryId',
    'item',
    'collectionIcon',
    'isCollectableUser',
    'lastItemMargin',
    'listColumns',
    'itemIndex',
    'listLength'
  ],
  computed: {
    pageId () {
      return this.$route.params.pageId
    },
    isMyCollection () {
      return this.$store.getters['collection/getIsMyCollectionItem'](this.item.collectionItemId)
    },
    getCategoryById () {
      return this.$store.getters['collection/getCategoryById'](this.categoryId)
    },
    itemStyle () {
      const setting = this.getCategoryById && this.getCategoryById.categorySetting
      const listTypeItem = setting && setting.listType === 'list' && {
        gridTemplateColumns: `${setting.itemRatio.image}fr ${setting.itemRatio.text}fr`
      }
      const img = setting && setting.display.includes('image') && this.getRelativeHeight(setting.imageRatio.width, setting.imageRatio.height)
      const name = setting && setting.display.includes('name') && setting.fontSize.name
      const descTop = setting && setting.display.includes('descTop') && setting.fontSize.descTop
      const descBottom = setting && setting.display.includes('descBottom') && setting.fontSize.descBottom
      const hasImg = this.item && this.item.attribute && this.item.attribute.imageList && this.item.attribute.imageList[0]
      const spacing = this.$store.getters['collection/getCommonItemStyle']
      return {
        listTypeItem: {
          ...listTypeItem
        },
        ...hasImg && img && {img: {
          paddingBottom: `${img}%`
        }},
        ...name && {name: {
          fontSize: `${name}px`,
          ...spacing && spacing.name && {
            letterSpacing: spacing.name
          }
        }},
        ...descTop && {descTop: {
          fontSize: `${descTop}px`,
          ...spacing && spacing.descTop && {
            letterSpacing: spacing.descTop
          }
        }},
        ...descBottom && {descBottom: {
          fontSize: `${descBottom}px`,
          ...spacing && spacing.descBottom && {
            letterSpacing: spacing.descBottom
          }
        }}
      }
    },
  },
  methods: {
    getItemThumb (item) {
      return item && item.attribute && item.attribute.imageList && item.attribute.imageList[0]
    },
    // 이미지 비율 구하기
    getRelativeHeight (widthStr, heightStr) {
      const width = parseFloat(widthStr)
      const height = parseFloat(heightStr)

      if (!width || !height) {
        return 64 // 그냥 기본 64%
      }

      const ratio = (height / width) * 100
      return ratio // 세로 비율 (단위: %)
    },
    setDetail (item) {
      if (item.attribute.detailActive) {
        const detailType = item.attribute.detailType
        if (detailType === 'gallery') {
          this.$store.commit('collection/setDetailGallery', item.collectionItemId)
        } else if (detailType === 'embed') {
          this.$store.commit('collection/setDetailVideo', item.collectionItemId)
        } else {
          this.$router.push({
            name: 'collectionDetail',
            params: {
              ...this.$route.params,
              collectionItemId: item.collectionItemId
            }
          })
        }
      }
    },
    async toggleCollection (item) {
      const func = this.isMyCollection ? 'collection/removeMyCollectionItem' : 'collection/addCollection'
      const collectionCategory = this.collectionIcon.collectionCategory
      const data = {
        pageId: this.pageId,
        collectionCategory: collectionCategory,
        ...this.isMyCollection ? {
          orderItemId: item.collectionItemId
        } : {
          collectionItemId: item.collectionItemId
        }
      }
      this.$store.commit('loading', true)
      const res = await this.$store.dispatch(func, data)
      if (this.isMyCollection) {
        if (res && res.status === 200) {
          this.$store.commit('collection/setToastMessage', '내 콜렉션에서 삭제되었습니다.')
        }
      } else {
        if (res && res.result && res.result.orderUUID) {
          this.$store.commit('collection/setToastMessage', '내 콜렉션에 추가되었습니다.')
        }
      }
      this.$store.dispatch('collection/getMyCollectionItems', { pageId: this.pageId })
      this.$store.commit('loading', false)
    }
  }
}
</script>